import { useSelector } from "react-redux";
import Pill from "../Pill/Pill";
import { Tooltip } from "antd";
// import { iprUpperIndexes, iprLowerIndexes } from "./utils";
import "./ipr.scss";
import { primaryColor } from "colors-config";
import { getToothNameLower, getToothNameUpper } from "./IprFrame/IPRInfo/data";

const Row = ({ row, pressure }) => {
  const { beforeStage, teethNo, iprValue, attachmentType, pressureLine } = row;
  return (
    <div className={pressure ? "attach-row": "attach-row"}>
      <div className="cell">
        <Pill option="circular" text={beforeStage} />
      </div>
      <div className="cell">
        <Pill
          option="rectangular"
          text={teethNo}
          color={primaryColor}
          textColor={"#fff"}
          style={{
            width: "80px",
            textAlign: "center",
            border: `3px solid ${primaryColor}`,
          }}
        />
      </div>
      <div className="cell">
        <Tooltip title={attachmentType}>
          <span>
            <Pill
              //   option="rectangular"
              // option="circular"
              style={{
                textAlign: "center",
                background: "#fff",
                color: "black",
                border: `3px solid #fff`,
              }}
              text={attachmentType}
              color={primaryColor}
              textColor={"#fff"}
            />
          </span>
        </Tooltip>
      </div>
      <div className="cell">
        {iprValue ? (
          <Tooltip title={iprValue ? iprValue : "--"}>
            <span>
              <Pill
                option="rectangular"
                style={{
                  width: "100%",
                  textAlign: "left",
                  justifyContent: "flex-start",
                  background: "#fff",
                  color: "black",
                  border: `3px solid #fff`,
                }}
                text={iprValue ? iprValue : "--"}
              />
            </span>
          </Tooltip>
        ) : null}
      </div>

      {
        pressure && (
   <div className="cell">
        <Tooltip
          title={
            pressureLine === "yes" ? " Pressure line Yes" : " Pressure line No"
          }
        >
          <span>
            <Pill
              option="rectangular"
              style={{
                textAlign: "center",
                textTransform: "capitalize",
                border:
                  pressureLine === "yes"
                    ? `3px solid ${primaryColor}`
                    : `3px solid #fff`,
                background: "#fff",
                color: "black",
              }}
              text={`${pressureLine}`}
              color={primaryColor}
              textColor={"#fff"}
            />
          </span>
        </Tooltip>
      </div>
        )
      }

   
    </div>
  );
};

const Divider = () => (
  <div style={{ width: "100%", height: "2px", background: "#393A3E" }}></div>
);

const AttachmentTable = ({
  upperModelIndex,
  lowerModelIndex,
  showIprTable,
  chartValue,
  pressure
}) => {
  const upperValues = [];
  const lowerValues = [];
  const attachmentDetails = useSelector(
    (state) => state.model.attachtmentDetails
  );

  attachmentDetails?.forEach((el) => {
    if (el.jawType === "upper" && el.aligner_count === upperModelIndex) {
      upperValues.push(el);
    }
    if (el.jawType === "lower" && el.aligner_count === lowerModelIndex) {
      lowerValues.push(el);
    }
  });

  const selectedAlignerDataUpper =
    upperValues?.length > 1
      ? upperValues?.filter((el) => el.aligner_count === upperModelIndex)
      : [upperValues[0]];
  const selectedAlignerDataLower =
    lowerValues?.length > 1
      ? lowerValues.filter((el) => el.aligner_count === lowerModelIndex)
      : [lowerValues[0]];

  const tableData = [];
  //   console.log("selectedAlignerDataUpper", selectedAlignerDataUpper)
  selectedAlignerDataUpper[0]?.alignerValues?.forEach((el, index) => {
    if (el?.value) {
      tableData.push({
        beforeStage: selectedAlignerDataUpper[0].aligner_count,
        teethNo: getToothNameUpper(el.teeth, chartValue),
        //  teethNo: iprUpperIndexes[index],
        iprValue: el.detail,
        attachmentType: el.attachmentType ? el.attachmentType : '--',
        pressureLine: el?.pressureLine ? el?.pressureLine : "no",
      });
    }
  });
  //   const beforeStageLower = lowerValues.length > 1 ? lowerModelIndex : 1;
  selectedAlignerDataLower[0]?.alignerValues?.forEach((el, index) => {
    if (el?.value) {
      tableData.push({
        beforeStage: selectedAlignerDataLower[0].aligner_count,
        teethNo: getToothNameLower(el.teeth, chartValue),
        // teethNo: el.teeth,
        // teethNo: iprLowerIndexes[index],
        iprValue: el.detail,
        attachmentType: el.attachmentType ? el.attachmentType : '--',
        pressureLine: el?.pressureLine ? el?.pressureLine : "no",
      });
    }
  });

  if (tableData?.length === 0)
    return <p className="empty-container">No Attachments for this stage</p>;

  return (
    <div>
      <div className="attachment-table-container">
        <div className={pressure ? "attach-row": "attach-row"}>
          <span className="table-col-attach">Before Stage #</span>
          <span className="table-col-attach">Tooth #</span>
          <span className="table-col-attach">Attachment Type</span>
          {/* <span className="table-col-attach">Detail</span> */}
          {pressure &&    <span className="table-col-attach">Pressure Line</span>}

        </div>

        <div className="ipr-table-container">
          {tableData.map((row, index) => (
            <div key={index}>
              <Row row={row} pressure={pressure} />
              {tableData.length - 1 !== index && <Divider />}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AttachmentTable;